export default __webpack_public_path__ + "static/performance-tooling-0125dc30e6fd87cf9b8090fd9b3747bf.png";